import get from 'lodash/get';

/**
 * Compare two semver strings and return true if the releaseVersion is greater than targetVersion.
 */
export function isVersionAtLeast(releaseVersion, targetVersion): boolean {
  const [semver] = String(releaseVersion).match(/^\d+\.\d+\.\d+/) || [];
  return !semver || semver.localeCompare(targetVersion, undefined, { numeric: true }) >= 0;
}

/**
 * Sorts an array of semvers strings
 * @param {any[]} items - Object array
 * @param {string} path - Dot notated string, path to version value
 * @param {'asc'|'desc'} order - Optional, whether or not sort is descending (ascending by default)
 * @returns {string[]} - Sorted string array
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function orderByVersion<T>(items: T[], path: string, order: 'asc' | 'desc' = 'asc'): T[] {
  const output = [...items];
  output.sort((a, b) => {
    const arrA = get(a, path).split('.');
    const arrB = get(b, path).split('.');
    for (let i = 0; i < Math.max(arrA.length, arrB.length); i++) {
      const itemA = arrA[i] || '';
      const itemB = arrB[i] || '';
      if (itemA?.includes('-') && !itemB.includes('-')) {
        return order === 'desc' ? 1 : -1;
      }
      if (!itemA.includes('-') && itemB.includes('-')) {
        return order === 'desc' ? -1 : 1;
      }
      const v1 = parseInt(itemA) || 0;
      const v2 = parseInt(itemB) || 0;
      if (v1 !== v2) {
        return order === 'desc' ? v2 - v1 : v1 - v2;
      }
    }
    return 0;
  });
  return output;
}
